var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoachPoliciesProcedures(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8724_127274)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 40C33.4934 40 42 31.4934 42 21C42 10.5066 33.4934 2 23 2C12.5066 2 4 10.5066 4 21C4 31.4934 12.5066 40 23 40Z",
    fill: "#00B6CA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7947 28.7101C20.7302 28.7101 22.2992 27.1411 22.2992 25.2056C22.2992 23.2702 20.7302 21.7012 18.7947 21.7012C16.8592 21.7012 15.2902 23.2702 15.2902 25.2056C15.2902 27.1411 16.8592 28.7101 18.7947 28.7101Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3078 19.5981H30.7096V13.9909C30.7096 13.805 30.6357 13.6268 30.5043 13.4953C30.3728 13.3639 30.1946 13.29 30.0087 13.29H24.4015V14.6918H28.3167L22.5042 20.5043C22.4373 20.569 22.3839 20.6463 22.3471 20.7318C22.3104 20.8174 22.2911 20.9093 22.2902 21.0024C22.2894 21.0955 22.3072 21.1877 22.3424 21.2739C22.3777 21.36 22.4297 21.4383 22.4955 21.5041C22.5613 21.5699 22.6396 21.6219 22.7257 21.6572C22.8118 21.6924 22.9041 21.7102 22.9972 21.7093C23.0903 21.7085 23.1822 21.6892 23.2678 21.6525C23.3533 21.6157 23.4306 21.5623 23.4953 21.4954L29.3078 15.6829V19.5981Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9911 19.1875L18.0937 17.0848L20.1964 19.1875L21.1875 18.1964L19.0848 16.0937L21.1875 13.9911L20.1964 13L18.0937 15.1027L15.9911 13L15 13.9911L17.1027 16.0937L15 18.1964L15.9911 19.1875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23.8036L30.0089 22.8125L27.9062 24.9152L25.8036 22.8125L24.8125 23.8036L26.9152 25.9062L24.8125 28.0089L25.8036 29L27.9062 26.8973L30.0089 29L31 28.0089L28.8973 25.9062L31 23.8036Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8724_127274",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.902115 0 0 0 0 0.923645 0 0 0 0 0.967448 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8724_127274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8724_127274",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachPoliciesProcedures);
export default __webpack_public_path__ + "static/media/coach_policies_procedures.cb5d8dd15d5018c3d2266fd8a8c10011.svg";
export { ForwardRef as ReactComponent };